import { memo, useMemo } from 'react'

import DigitalExperienceIcon from 'assets/icons/categories/Digital Experience.svg'
import InnovationIcon from 'assets/icons/categories/Innovation.svg'
import LiveIcon from 'assets/icons/categories/live.svg'
import LocalGemsIcon from 'assets/icons/categories/Local Gems.svg'
import MindBlowingIcon from 'assets/icons/categories/Mind-blowing Creativity.svg'
import ProductIcon from 'assets/icons/categories/prod.svg'
import RetailExperienceIcon from 'assets/icons/categories/Retail Experience.svg'
import TransformationCatalystIcon from 'assets/icons/categories/Transformation Catalyst.svg'
import { AwardsCard } from 'components/awardCard/AwardsCard'
import { AwardsFile } from 'types/AwardsFile'

export interface AwardsCategorySliderProps {
  title: string
  description?: string
  category: string
  awards: AwardsFile[]
  loadingStrategy?: 'lazy' | 'eager'
  categoryIcon?: boolean
}

export const AwardsCategorySlider = memo((props: AwardsCategorySliderProps) => {
  const { title, description, category, awards, categoryIcon = true } = props

  const filteredAwards = useMemo(() => {
    return awards?.filter(award => award.category === category)
  }, [awards, category])

  const sortedAwards = useMemo(() => {
    return filteredAwards.sort((a, b) => {
      if (b.winner !== a.winner) {
        return b.winner - a.winner
      }
      if (b.braveBoundless !== a.braveBoundless) {
        return b.braveBoundless - a.braveBoundless
      }
      if (b.shortlist !== a.shortlist) {
        return b.shortlist - a.shortlist
      }
      return 0
    })
  }, [filteredAwards])

  const titleIcons: any = {
    'Product Experience': ProductIcon,
    'Live Experience': LiveIcon,
    'Local Gems': LocalGemsIcon,
    'Digital Experience': DigitalExperienceIcon,
    'Retail Experience': RetailExperienceIcon,
    'Mind-blowing Creativity': MindBlowingIcon,
    Innovation: InnovationIcon,
    'Transformation Catalyst': TransformationCatalystIcon,
  }

  return (
    <>
      {sortedAwards.length > 0 ? (
        <div>
          <div className="max-w-[1152px] pb-12">
            <h2 className="uppercase font-TCCCtext font-[700] text-2xl mb-[32px] flex text-[#967337] items-center">
              {categoryIcon && <img src={titleIcons[title]} alt="" className="pr-3" />}
              <span>{title}</span>
            </h2>
            {description && <h3 className="text-[18px] font-TCCCtext font-[400] my-2">{description}</h3>}
            <div className="flex flex-wrap justify-between gap-4">
              {filteredAwards.map(award => (
                <div>
                  <AwardsCard key={award.id} award={award} />
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
})
